import { Component, Host, h, Prop, State, Listen, Element } from '@stencil/core';

@Component({
    tag: 'sew-ws-linklist-menu',
    styleUrl: 'sew-ws-linklist-menu.scss',
    shadow: true,
})
export class SewWsLinklistMenu {
    @Element() private el: HTMLSewWsLinklistMenuElement;
    @Prop() headline: string;

    @State() isOpened = false;

    @Listen('click', { target: 'window' })
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    checkForClickOutside(eventWindowClicked): void {
        const path =
            eventWindowClicked.path || (eventWindowClicked.composedPath && eventWindowClicked.composedPath());

        if (path.every(el => el !== this.el)) {
            this.isOpened = false;
        }
    }

    private toggleComponent(): void {
        this.isOpened = !this.isOpened;
    }

    render() {
        return (
            <Host>
                <button
                    aria-expanded={this.isOpened ? 'true' : 'false'}
                    onClick={() => this.toggleComponent()}
                >
                    <span>{this.headline}</span>
                    <sew-icon
                        class={{ svg: true, rotate: this.isOpened }}
                        icon={'arrow-chevron-down'}
                    ></sew-icon>
                </button>
                <sew-menu class="sew-ws wrap" open={this.isOpened}>
                    <slot></slot>
                </sew-menu>
            </Host>
        );
    }
}
